/*
 * @Author: your name
 * @Date: 2020-11-25 20:41:28
 * @LastEditTime: 2021-11-09 14:09:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/localStorageModules/mutations.js
 */

export const GET_SIGN_UP_POPUP_ONCE_TIME = 'GET_SIGN_UP_POPUP_ONCE_TIME'
export const SET_SIGN_UP_POPUP_ONCE_TIME = 'SET_SIGN_UP_POPUP_ONCE_TIME'

export const GET_VENUE_CLOSE_POPUP_ONCE_TIME = 'GET_VENUE_CLOSE_POPUP_ONCE_TIME'
export const SET_VENUE_CLOSE_POPUP_ONCE_TIME = 'SET_VENUE_CLOSE_POPUP_ONCE_TIME'
export const DEL_VENUE_CLOSE_POPUP_ONCE_TIME = 'DEL_VENUE_CLOSE_POPUP_ONCE_TIME'

export const GET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME = 'GET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME'
export const SET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME = 'SET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME'
export const DEL_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME = 'DEL_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME'

export const GET_VENUE_CLOSE_POS_POPUP = 'GET_VENUE_CLOSE_POS_POPUP'
export const SET_VENUE_CLOSE_POS_POPUP = 'SET_VENUE_CLOSE_POS_POPUP'
export const DEL_VENUE_CLOSE_POS_POPUP = 'DEL_VENUE_CLOSE_POS_POPUP'

export const GET_TAB_PASS_CODE = 'GET_TAB_PASS_CODE'
export const SET_TAB_PASS_CODE = 'SET_TAB_PASS_CODE'